const PRODUCTION_ORIGIN = "https://lessonlaunchpad.com";

/**
 * Current site origin for in-app navigation and share links.
 * Prefer React Router <Link to="..."> for internal routes — it is always origin-aware.
 */
export function getAppOrigin() {
  if (typeof window !== "undefined" && window.location?.origin) {
    return window.location.origin;
  }

  return (
    process.env.REACT_APP_PUBLIC_ORIGIN ||
    process.env.REACT_APP_CANONICAL_ORIGIN ||
    PRODUCTION_ORIGIN
  );
}

/**
 * Canonical origin for SEO meta tags and sitemaps.
 * - Production: always apex lessonlaunchpad.com
 * - Stage/local: uses REACT_APP_CANONICAL_ORIGIN at build time, or window.location.origin at runtime
 */
export function getCanonicalOrigin() {
  if (process.env.REACT_APP_CANONICAL_ORIGIN) {
    return process.env.REACT_APP_CANONICAL_ORIGIN.replace(/\/$/, "");
  }

  if (typeof window !== "undefined") {
    const { origin, hostname } = window.location;

    if (hostname === "lessonlaunchpad.com" || hostname === "www.lessonlaunchpad.com") {
      return PRODUCTION_ORIGIN;
    }

    if (
      hostname === "localhost" ||
      hostname === "127.0.0.1" ||
      hostname.includes("stage.lessonlaunchpad")
    ) {
      return origin;
    }

    return origin;
  }

  return PRODUCTION_ORIGIN;
}

/** Build an absolute URL on the current environment (or configured origin). */
export function appUrl(path = "/") {
  const origin = getAppOrigin();

  if (!path || path === "/") {
    return `${origin}/`;
  }

  return `${origin}${path.startsWith("/") ? path : `/${path}`}`;
}

/** Build a canonical URL for SEO tags. */
export function canonicalUrl(path = "/") {
  const origin = getCanonicalOrigin();

  if (!path || path === "/") {
    return `${origin}/`;
  }

  return `${origin}${path.startsWith("/") ? path : `/${path}`}`;
}

export { PRODUCTION_ORIGIN };
